import { createI18n } from "vue-i18n";
import enLocale from 'element-plus/lib/locale/lang/en'
import zhLocale from 'element-plus/lib/locale/lang/zh-cn'
import fa from 'element-plus/lib/locale/lang/fa'
import ar from 'element-plus/lib/locale/lang/ar'
import langs from './lang'

const chunkLang = (data: DefaultObjectType) => {
  let obj: DefaultObjectType = {}
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      let d = data[key]
      Object.keys(d).forEach((k) => {
        obj[k] = obj[k] || {}
        obj[k][key] = d[k]
      })
    }
  }
  return obj
}

const languages = chunkLang(langs)

const i18n = createI18n({
  legacy: false, 
  locale: localStorage.getItem('language') || 'en',
  globalInjection: true,
  fallbackLocale: localStorage.getItem('language') || 'en',
  messages: {
    zh: Object.assign(languages.zh, zhLocale),
    en: Object.assign(languages.en, enLocale),
    ar: Object.assign(languages.ar, ar),
    fa: Object.assign(languages.fa, fa),
  },
  silentTranslationWarn: true,
  silentFallbackWarn: true,
})

export default i18n